export default __webpack_public_path__ + "static/hydrophilic-f3ee34a64777537b4aeb8daeddae3279.jpg";